module.exports = __webpack_public_path__ + "img/start-image.a56f7888.jpg";